export default "__VITE_ASSET__Bq3VbUHg__"